import { render, staticRenderFns } from "./CompanyTobas.vue?vue&type=template&id=f112c036&"
import script from "./CompanyTobas.vue?vue&type=script&lang=js&"
export * from "./CompanyTobas.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTobas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports